const CDN_BANKS = '/images/banks';

export const BANKS = {
    '603799': {
        name: 'melli',
        label: 'ملی',
        color: '#EF3F3E',
        logo: `${CDN_BANKS}/melli.svg`
    },
    '589210': {
        name: 'sepah',
        label: 'سپه',
        color: '#FFC600',
        logo: `${CDN_BANKS}/sepah.svg`
    },
    '627648': {
        name: 'tosee-saderat',
        label: 'توسعه صادرات',
        color: '#EDB12C',
        logo: `${CDN_BANKS}/tosee-saderat.svg`
    },
    '627961': {
        name: 'sanat-madan',
        label: 'صنعت و معدن',
        color: '#B3986D',
        logo: `${CDN_BANKS}/sanat-madan.svg`
    },
    '603770': {
        name: 'keshavarzi',
        label: 'کشاورزی',
        color: '#4E7A46',
        logo: `${CDN_BANKS}/keshavarzi.svg`
    },
    '628023': {
        name: 'maskan',
        label: 'مسکن',
        color: '#F05A23',
        logo: `${CDN_BANKS}/maskan.svg`
    },
    '627760': {
        name: 'post-bank',
        label: 'پست بانک',
        color: '#00764D',
        logo: `${CDN_BANKS}/post-bank.svg`
    },
    '502908': {
        name: 'tosee-taavon',
        label: 'توسعه تعاون',
        color: '#0064A6',
        logo: `${CDN_BANKS}/tosee-taavon.svg`
    },
    '627412': {
        name: 'eghtesad-novin',
        label: 'اقتصاد نوین',
        color: '#652D86',
        logo: `${CDN_BANKS}/eghtesad-novin.svg`
    },
    '622106': {
        name: 'parsian',
        label: 'پارسیان',
        color: '#B3282D',
        logo: `${CDN_BANKS}/parsian.svg`
    },
    '502229': {
        name: 'pasargad',
        label: 'پاسارگاد',
        color: '#FFC72C',
        logo: `${CDN_BANKS}/pasargad.svg`
    },
    '627488': {
        name: 'karafarin',
        label: 'کارآفرین',
        color: '#3B9C56',
        logo: `${CDN_BANKS}/karafarin.svg`
    },
    '621986': {
        name: 'saman',
        label: 'سامان',
        color: '#006DB6',
        logo: `${CDN_BANKS}/saman.svg`
    },
    '62198618': {
        name: 'blubank',
        label: 'بلو',
        color: '#3094EA',
        logo: `${CDN_BANKS}/blubank.svg`
    },
    '62198619': {
        name: 'blubank',
        label: 'بلو',
        color: '#3094EA',
        logo: `${CDN_BANKS}/blubank.svg`
    },
    '639346': {
        name: 'sina',
        label: 'سینا',
        color: '#004E8A',
        logo: `${CDN_BANKS}/sina.svg`
    },
    '639607': {
        name: 'sarmayeh',
        label: 'سرمایه',
        color: '#0077B6',
        logo: `${CDN_BANKS}/sarmayeh.svg`
    },
    '636214': {
        name: 'melli',
        label: 'ملی (آینده سابق)',
        color: '#EF3F3E',
        logo: `${CDN_BANKS}/melli.svg`
    },
    '502806': {
        name: 'shahr',
        label: 'شهر',
        color: '#ED3438',
        logo: `${CDN_BANKS}/shahr.svg`
    },
    '502938': {
        name: 'day',
        label: 'دی',
        color: '#0099CC',
        logo: `${CDN_BANKS}/day.svg`
    },
    '603769': {
        name: 'saderat',
        label: 'صادرات',
        color: '#1A3266',
        logo: `${CDN_BANKS}/saderat.svg`
    },
    '610433': {
        name: 'mellat',
        label: 'ملت',
        color: '#D70005',
        logo: `${CDN_BANKS}/mellat.svg`
    },
    '627353': {
        name: 'tejarat',
        label: 'تجارت',
        color: '#005696',
        logo: `${CDN_BANKS}/tejarat.svg`
    },
    '585983': {
        name: 'tejarat',
        label: 'تجارت',
        color: '#005696',
        logo: `${CDN_BANKS}/tejarat.svg`
    },
    '589463': {
        name: 'refah',
        label: 'رفاه',
        color: '#2B3C8E',
        logo: `${CDN_BANKS}/refah.svg`
    },
    '627381': {
        name: 'sepah',
        label: 'سپه (انصار سابق)',
        color: '#FFC600',
        logo: `${CDN_BANKS}/sepah.svg`
    },
    '505785': {
        name: 'iran-zamin',
        label: 'ایران زمین',
        color: '#92278F',
        logo: `${CDN_BANKS}/iran-zamin.svg`
    },
    '505416': {
        name: 'gardeshgari',
        label: 'گردشگری',
        color: '#1D3265',
        logo: `${CDN_BANKS}/gardeshgari.svg`
    },
    '636949': {
        name: 'hekmat',
        label: 'حکمت',
        color: '#5F2C83',
        logo: `${CDN_BANKS}/hekmat.svg`
    },
    '505801': {
        name: 'kosar',
        label: 'کوثر',
        color: '#C62828',
        logo: `${CDN_BANKS}/kosar.svg`
    },
    '606373': {
        name: 'mehr-iran',
        label: 'مهر ایران',
        color: '#359E49',
        logo: `${CDN_BANKS}/mehr-iran.svg`
    },
    '504172': {
        name: 'resalat',
        label: 'رسالت',
        color: '#000000',
        logo: `${CDN_BANKS}/resalat.svg`
    },
    '523388': {
        name: 'pasargad',
        label: 'پاسارگاد (ویپاد)',
        color: '#FFC72C',
        logo: `${CDN_BANKS}/pasargad.svg`
    },
    '505809': {
        name: 'khavarmianeh',
        label: 'خاورمیانه',
        color: '#1F2B5B',
        logo: `${CDN_BANKS}/khavarmianeh.svg`
    }
} as const;

export const SHEBA_CODES: Record<string, string> = {
    '011': '627961',
    '012': '610433',
    '013': '589463',
    '014': '628023',
    '015': '589210',
    '016': '603770',
    '017': '603799',
    '018': '627353',
    '019': '603769',
    '020': '627648',
    '021': '627760',
    '022': '502908',
    '053': '627488',
    '054': '622106',
    '055': '627412',
    '056': '621986',
    '057': '502229',
    '058': '639607',
    '059': '639346',
    '060': '606373',
    '061': '502806',
    '062': '636214',
    '063': '627381',
    '064': '505416',
    '065': '636949',
    '066': '502938',
    '069': '505785',
    '070': '504172',
    '078': '505809'
};
